export interface CrmFeature {
  id: string;
  feature_key: string;
  display_name: string;
  description: string | null;
  icon_name: string | null;
  sidebar_order: number;
  is_premium: boolean;
  created_at: string;
  updated_at: string;
}

export interface ClubFeatureAccess {
  id: string;
  club_id: string;
  feature_key: string;
  is_enabled: boolean;
  enabled_by: string | null;
  enabled_at: string | null;
  disabled_at: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

// Map of feature keys to their route paths
export const FEATURE_KEY_TO_PATH: Record<string, string> = {
  'member-management': '/club-admin/members',
  'staff-management': '/club-admin/staff',
  'course-management': '/club-admin/courses',
  'booking-system': '/club-admin/bookings',
  'cart-management': '/club-admin/services/carts',
  'event-management': '/club-admin/events',
  'communication-channels': '/club-admin/communication',
  'announcement-system': '/club-admin/announcements',
  'feedback': '/club-admin/feedback',
  'crm-analytics': '/club-admin/analytics',
  'crm-reports': '/club-admin/reports',
  'club-settings': '/club-admin/settings',
};

// Map of paths to feature keys (reverse lookup)
export const PATH_TO_FEATURE_KEY: Record<string, string> = Object.entries(
  FEATURE_KEY_TO_PATH
).reduce((acc, [key, path]) => {
  acc[path] = key;
  return acc;
}, {} as Record<string, string>);
